import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { fetchBrokerRatingSummary } from '../lib/brokerReviews';
import StarRating from './StarRating';
import './BrokerRatingSummary.css';

export default function BrokerRatingSummary({ brokerId, onCountLoaded }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    fetchBrokerRatingSummary(brokerId).then((s) => {
      setSummary(s);
      if (onCountLoaded) onCountLoaded(s.count);
    });
  }, [brokerId, onCountLoaded]);

  if (!summary) return <div className="brs brs--loading" />;

  const { average, count, breakdown } = summary;

  return (
    <div className="brs">
      <h3 className="brs__title">Reviews</h3>

      {count === 0 ? (
        <div className="brs__empty">
          <Star size={22} fill="#7C3AED" stroke="#7C3AED" strokeWidth={1.5} />
          <span>No reviews yet — be the first to leave one below.</span>
        </div>
      ) : (
        <div className="brs__overview">
          <div className="brs__score-col">
            <span className="brs__avg">{average}</span>
            <StarRating value={average} readonly size="medium" />
            <span className="brs__count">{count} {count === 1 ? 'review' : 'reviews'}</span>
          </div>

          <div className="brs__bars-col">
            {[5, 4, 3, 2, 1].map((star) => (
              <div key={star} className="brs__bar-row">
                <span className="brs__bar-num">{star}</span>
                <Star size={12} fill="#7C3AED" stroke="#7C3AED" strokeWidth={1.5} />
                <div className="brs__bar-track">
                  <div
                    className="brs__bar-fill"
                    style={{ width: count > 0 ? `${(breakdown[star] / count) * 100}%` : '0%' }}
                  />
                </div>
                <span className="brs__bar-count">{breakdown[star]}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
